import { hasNonDigitCharacters } from '../helpers/index.js';
var validOgrn = function validOgrn(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный ОГРН' : _c,
    _d = _b.invalidCharactersMessage,
    invalidCharactersMessage = _d === void 0 ? 'ОГРН может соcтоять только из цифр' : _d,
    _e = _b.invalidLengthMessage,
    invalidLengthMessage = _e === void 0 ? 'ОГРН состоит из 13 цифр' : _e;
  return function (value) {
    if (!value || !value.trim()) {
      return message;
    }
    if (hasNonDigitCharacters(value)) {
      return invalidCharactersMessage;
    }
    if (value.length !== 13) {
      return invalidLengthMessage;
    }
    var n13 = parseInt((parseInt(value.slice(0, -1)) % 11).toString().slice(-1));
    if (n13 !== parseInt(value[12])) {
      return message;
    }
    return;
  };
};
export { validOgrn };